import { useSearchParams } from "react-router-dom";

import Logout from "src/components/auth/Logout";

export default function LogoutPage() {
  const [searchParams] = useSearchParams();

  return <Logout isRedirectedFromOldApp={searchParams.has("redirected")} />;
}
